import { getClient, getBaseOrMockURL, traceDetails } from './client';
import { ModelResults } from './ModelResults';

const commerceAIModelResults = (pub: boolean, baseUrl: string) => new ModelResults(getClient(pub, getBaseOrMockURL(baseUrl), traceDetails));
export default commerceAIModelResults;
